import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import * as actionTypes from '../constants/scenario-eval-template-evals-action-types';

import type {List, Map} from 'immutable';

export type ScenarioEvalTemplateEvalsStore = {
    evals: List<unknown>;
    evalTemplate: Map<unknown, unknown>;
};

const initialState = () => {
    return {
        evals: Immutable.List(),
        evalTemplate: Immutable.Map(),
    };
};

const actionsMap = {
    [actionTypes.GET_EVAL_TEMPLATE_SUCCESS]: (state, action) => {
        return {
            evalTemplate: action.data,
        };
    },
    [actionTypes.GET_EVALS_SUCCESS]: (state, action) => {
        return {
            evals: action.data,
        };
    },
    [actionTypes.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<ScenarioEvalTemplateEvalsStore>(initialState(), actionsMap);
